import type React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { BackpackIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface BackpackAttributeCardProps extends WithDataTestid, WithClassNameProp {
  backpack: 0 | 1 | 2 | null;
}

export function BackpackAttributeCard({
  backpack,
  className = undefined,
  'data-testid': dataTestId = 'BackpackAttributeCard',
  ...props
}: BackpackAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();
  const description = EVENT_ENUMS.ACCESSORIES.BACKPACK[backpack].label;

  return (
    <AttributeCard
      className={className}
      data={backpack}
      data-testid={dataTestId}
      description={description}
      icon={<BackpackIcon />}
      title={t('shared:attribute_cards.backpack.title')}
      {...props}
    />
  );
}
